import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { LeaveRequestStatus } from '../../../commonTypes/leaveRequest.types';
import { useContainer } from '../../useContainer';
import { LeaveRequestUserInfoIncluded } from '../../../commonTypes/acs';
import { DateTime } from 'luxon';
import { useTranslation } from '../../useTranslation';

const useHttpGetLeaveRequestsByIntervalOMX = (from: string, to: string, status?: LeaveRequestStatus[], search?: string, currentMonth?: DateTime) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [leaveRequests, setLeaveRequests] = useState<LeaveRequestUserInfoIncluded[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const toastHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const getLeaveRequests = () => {
        setIsLoading(true);
        const { exec, abort } = acsApi.getLeaveRequestsByInterval({
            query: { search },
            body: { from, to, status },
            onSuccess: res => {
                if (search && search !== '' && res.body.length === 0) {
                    const monthToDisplay = currentMonth || DateTime.fromISO(to);
                    const month = monthToDisplay.toFormat('LLLL');
                    const warn = t('leaveRequest.searchWarn').replace('SEARCH_MONTH', month).replace('SEARCH_CRITERIA', search);
                    toastHandler.push('warn', t('leaveRequest.searchTitle'), warn);
                }
                setLeaveRequests(res.body);
                setIsLoading(false);
            },
            onError: error => {
                setIsLoading(false);
                return error;
            },
        });

        exec();
        return abort;
    };

    useEffect(() => {
        getLeaveRequests();
    }, [from, to, search]);

    return { getLeaveRequests, leaveRequests, setLeaveRequests, isLoading };
};

export default useHttpGetLeaveRequestsByIntervalOMX;
